module.exports = __webpack_public_path__ + "img/1.169d9e44.jpg";